import { render, staticRenderFns } from "./cDataCaptureQuestionnaireSummary.vue?vue&type=template&id=3ce883f6&scoped=true"
import script from "./cDataCaptureQuestionnaireSummary.vue?vue&type=script&lang=js"
export * from "./cDataCaptureQuestionnaireSummary.vue?vue&type=script&lang=js"
import style0 from "./cDataCaptureQuestionnaireSummary.vue?vue&type=style&index=0&id=3ce883f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce883f6",
  null
  
)

export default component.exports